/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PeStars from '@pe-libs/react-components/build/components/PeStars';
import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import useIntlNumber from '@pe-libs/react-components/build/lib/intl/hooks/useIntlNumber';
import React, { FC } from 'react';
import messages from './messages';
import useStyles from './styles';

type Props = {
  averageRatingScore: number;
  scenario: string;
  totalRatingCount: number;
};

const Stars: FC<Props> = ({ averageRatingScore, scenario, totalRatingCount }) => {
  const formatMessage = useIntlMessage();
  const formatNumber = useIntlNumber();
  const styles = useStyles();
  const maxRating = formatNumber(5);

  return (
    <div onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => event.stopPropagation()}>
      {totalRatingCount > 0 ? (
        scenario === 'a' && (
          <div className={styles.starsContainer}>
            <div className={styles.starsSvgContainer}>
              {averageRatingScore > 0 ? (
                <PeStars
                  ratingValue={averageRatingScore}
                  minRatingZero={true}
                  writtenScore={true}
                  translations={{
                    poor: formatMessage(messages.poor),
                    negative: formatMessage(messages.negative),
                    neutral: formatMessage(messages.neutral),
                    positive: formatMessage(messages.positive),
                    excellent: formatMessage(messages.excellent),
                  }}
                />
              ) : (
                <PeStars
                  ratingValue={averageRatingScore}
                  minRatingZero={true}
                  translations={{
                    poor: formatMessage(messages.poor),
                    negative: formatMessage(messages.negative),
                    neutral: formatMessage(messages.neutral),
                    positive: formatMessage(messages.positive),
                    excellent: formatMessage(messages.excellent),
                  }}
                />
              )}
            </div>
            <span className={styles.starsText}>{`${formatNumber(averageRatingScore)} / ${maxRating}`}</span>
          </div>
        )
      ) : (
        <div className={styles.starsContainer}>
          <div className={styles.starsSvgContainer}>
            <PeStars ratingValue={0} minRatingZero={true} />
          </div>
          <span className={styles.starsText}>{`${formatNumber(averageRatingScore)} / ${maxRating}`}</span>
        </div>
      )}
    </div>
  );
};

export default Stars;
